var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time"},[_c('p',[_vm._v(_vm._s(_vm.timerHours)+":"+_vm._s(_vm.timerMinutes)+":"+_vm._s(_vm.timerSeconds))])])
}
var staticRenderFns = []

export { render, staticRenderFns }